const { useSelector } = require("react-redux");

export const useIsEmailVerified = () => {
  const { user } = useSelector(state => state.account);
  return {
    email_v: user && user.email_v === 1,
    golflink_v: user && user.golflink_v === 1
  };
};
